import { useState } from 'react';
import { useScrollReveal } from '../../hooks/useScrollReveal';

const testimonials = [
  {
    id: 1,
    name: 'María Elena Castellanos',
    role: 'Cliente Alta Costura — Madrid',
    quote: 'Anthony no solo diseñó mi vestido de gala, creó una pieza de arte que capturó mi esencia. La atención en su atelier de Barcelona fue de una exclusividad que nunca había experimentado. Cada detalle, desde el bordado hasta el ajuste final, refleja una dedicación artesanal inigualable.',
    image: '/experiencia/exp-07.jpg',
  },
  {
    id: 2,
    name: 'Isabella Rossi',
    role: 'Cliente Alta Costura — Milán',
    quote: 'Viajé desde Milán específicamente para conocer el atelier de Anthony en Barcelona. Su visión del lujo artesanal es única en Europa. Mi vestido para la Fashion Week fue un éxito absoluto. La combinación de técnica española y sensibilidad parisina crea algo verdaderamente especial.',
    image: '/experiencia/exp-10.jpg',
  },
  {
    id: 3,
    name: 'Laura Fernández',
    role: 'Cliente Prêt-à-porter — Barcelona',
    quote: 'Llevé un abrigo de lana para ajustarlo y quedé impresionada con la rapidez y profesionalidad. En menos de una semana tenía una prenda que parecía hecha exclusivamente para mí. Los precios son justos y el trato es cercano. Recomiendo sus servicios de arreglo sin dudarlo.',
    image: '/experiencia/exp-16.jpg',
  },
];

export default function TestimonialsSection() {
  const { ref, isVisible, style } = useScrollReveal({ threshold: 0.1, distance: 36, duration: 900 });
  const [current, setCurrent] = useState(0);

  const prev = () => setCurrent((c) => (c === 0 ? testimonials.length - 1 : c - 1));
  const next = () => setCurrent((c) => (c === testimonials.length - 1 ? 0 : c + 1));

  const t = testimonials[current];

  return (
    <section className="w-full bg-white py-20 md:py-36">
      <div ref={ref} className="px-6 lg:px-[7%]" style={style}>
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          {/* Image */}
          <div className="lg:w-[38%] flex-shrink-0">
            <div className="aspect-[3/4] max-h-[600px] rounded-[32px] overflow-hidden">
              <img
                key={t.id}
                src={t.image}
                alt={t.name}
                className="w-full h-full object-cover object-top transition-all duration-700"
              />
            </div>
          </div>

          {/* Content */}
          <div className="lg:w-[62%] flex flex-col justify-center lg:pl-10">
            <span className="font-sans text-brand-gray-400 text-sm font-normal">
              (Testimonios de Clientes)
            </span>

            <h2 className="font-serif text-brand-black text-[clamp(2.5rem,5vw,4rem)] font-semibold leading-[1.1] mt-4">
              Palabras de
              <br />
              <span className="text-brand-gray-300">Quienes Nos</span>
              <br />
              Conocen
            </h2>

            <div className="mt-10 lg:mt-14 relative">
              <span className="font-serif text-brand-gray-300 text-5xl leading-none absolute -top-6 -left-2">
                &ldquo;
              </span>
              <p className="font-serif text-brand-gray-600 text-lg md:text-xl leading-[1.7] pl-4">
                {t.quote}
              </p>
              <span className="font-serif text-brand-gray-300 text-5xl leading-none absolute -bottom-8 right-0">
                &rdquo;
              </span>
            </div>

            <div className="mt-10 lg:mt-14">
              <span className="font-sans text-brand-black text-lg font-bold">
                — {t.name}
              </span>
              <p className="font-sans text-brand-gray-400 text-sm mt-1">
                {t.role}
              </p>
            </div>

            {/* Navigation */}
            <div className="mt-10 flex gap-4">
              <button
                onClick={prev}
                className="w-14 h-14 rounded-full border border-brand-gray-200 flex items-center justify-center text-brand-gray-400 hover:border-brand-gray-400 hover:text-brand-black transition-all duration-300"
                aria-label="Anterior testimonio"
              >
                <i className="ri-arrow-left-line text-lg" />
              </button>
              <button
                onClick={next}
                className="w-14 h-14 rounded-full bg-brand-black flex items-center justify-center text-white hover:bg-brand-gray-600 transition-all duration-300"
                aria-label="Siguiente testimonio"
              >
                <i className="ri-arrow-right-line text-lg" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}